/* global ADV */

export default () =>
  new Promise(resolve => {
    ADV.util.popup.confirm(
      'You have unsaved changes on this page. Are you sure you want to leave?',
      [
        {
          label: 'Leave This Page',
          classes: 'red',
        },
        {
          label: 'Cancel',
          classes: 'dismiss secondary',
        },
      ],
      choice => {
        if (choice === 0) {
          ADV.util.Router.unregisterNavigateAwayCallback();
          resolve(true);
        } else {
          resolve(false);
        }
      },
    );
  });
